// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Table,
//   Button,
//   Badge,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Input,
//   Label
// } from "reactstrap";

// const AssignTrainingsModal = ({ isOpen, toggle, server }) => {
//   const [selected, setSelected] = useState([]);

//   // dummy flashcards – replace with API
//   const flashcards = [
//     { id: 1, name: "BBQ Platter", course: "Main Course" },
//     { id: 2, name: "Beef Skewers", course: "Appetizer" },
//     { id: 3, name: "Beef Tartare", course: "Appetizer" }
//   ];

//   const toggleCard = (id) => {
//     setSelected((prev) =>
//       prev.includes(id)
//         ? prev.filter((x) => x !== id)
//         : [...prev, id]
//     );
//   };

//   if (!server) return null;

//   return (
//     <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
//       <ModalHeader toggle={toggle}>
//         Assign Trainings to {server.name}
//         <div className="text-muted small">
//           Click on flashcards to select them for training assignment
//         </div>
//       </ModalHeader>

//       <ModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
//         <Row className="g-3">
//           {flashcards.map((card) => {
//             const active = selected.includes(card.id);
//             return (
//               <Col md="6" key={card.id}>
//                 <div
//                   onClick={() => toggleCard(card.id)}
//                   className={`border rounded p-3 position-relative ${
//                     active ? "border-primary" : ""
//                   }`}
//                   style={{ cursor: "pointer" }}
//                 >
//                   <h6 className="mb-1">{card.name}</h6>
//                   <Badge color="success">{card.course}</Badge>

//                   {active && (
//                     <i
//                       className="ri-check-line text-primary position-absolute"
//                       style={{ top: 10, right: 10 }}
//                     />
//                   )}
//                 </div>
//               </Col>
//             );
//           })}
//         </Row>
//       </ModalBody>

//       <ModalFooter className="w-100 justify-content-between">
//         <span className="text-muted">{selected.length} selected</span>
//         <div>
//           <Button outline onClick={toggle}>Cancel</Button>
//           <Button color="primary" className="ms-2">
//             Assign Selected
//           </Button>
//         </div>
//       </ModalFooter>
//     </Modal>
//   );
// };

// export default AssignTrainingsModal;

import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const AssignTrainingsModal = ({
  isOpen,
  toggle,
  server,
  refreshServerList
}) => {
  
  const [flashcards, setFlashcards] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // ✅ Fetch flashcards
  const fetchFlashcards = () => {
    setLoading(true);

    postDataAPI({
      serviceName: "item_data",
      op: "server_coaching_outlet_items",
      display_classcification: "Yes",
      type: "Flash",
      status: "Active",
      load: 1,
      is_show_all: true,
      course_id: "",
      flash_status: "Complete"
    })
      .then((res) => {
        if (res.status === "ok") {
          setFlashcards(res.data.server_data || []);
        }
      })
      .finally(() => setLoading(false));
  };

  // ✅ Init modal data
  useEffect(() => {
    if (isOpen && server) {
      fetchFlashcards();

      // Pre-select already assigned cards
      setSelected(
        Array.isArray(server.flash_cards)
          ? server.flash_cards.map(String)
          : []
      );
    }
  }, [isOpen, server]);

  // ✅ Toggle card
  const toggleCard = (id) => {
    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  // ✅ Assign API
  const handleAssign = () => {
    if (!selected.length) {
      alert("Please select at least one flashcard");
      return;
    }

    setSaving(true);

    postDataAPI({
      serviceName: "server_data",
      op: "create_update_server_flash_cards",
      server_id: server.server_id,
      flash_card_id: selected
    })
      .then((res) => {
        if (res.status === "ok") {
          toggle();
          refreshServerList && refreshServerList();
        } else {
          alert(res.message || "Failed to assign flashcards");
        }
      })
      .finally(() => setSaving(false));
  };

  if (!server) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        Assign Trainings to {server.name}
        <div className="text-muted small">
          Select flashcards to assign or unassign
        </div>
      </ModalHeader>

      <ModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
        {loading ? (
          <p className="text-center text-muted">Loading flashcards...</p>
        ) : (
          <Row className="g-3">
            {flashcards.map((card) => {
              const id = String(card.flash_id);
              const active = selected.includes(id);

              return (
                <Col md="6" key={id}>
                  <div
                    onClick={() => toggleCard(id)}
                    className={`border rounded p-3 position-relative ${
                      active ? "border-primary bg-light" : ""
                    }`}
                    style={{ cursor: "pointer" }}
                  >
                    <h6 className="mb-1">{card.item_name}</h6>
                    <Badge color="primary">{card.course_name}</Badge>

                    {active && (
                      <i
                        className="ri-check-line text-primary position-absolute"
                        style={{ top: 10, right: 10, fontSize: 18 }}
                      />
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </ModalBody>

      <ModalFooter className="w-100 justify-content-between">
        <span className="text-muted">
          {selected.length} selected
        </span>

        <div>
          <Button outline onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            className="ms-2"
            onClick={handleAssign}
            disabled={saving}
          >
            {saving ? "Assigning..." : "Assign Selected"}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default AssignTrainingsModal;
